const services = [
  {
    id: 'cilt-bakimi',
    name: 'Cilt Bakımı',
    category: 'Yüz Bakımı',
    desc: 'Cildinizin ihtiyacına özel derin temizlik ve nemlendirme protokolleri ile sağlıklı, ışıltılı bir cilde kavuşun.',
    benefits: ['Derin gözenek temizliği', 'Nem dengesi ve parlaklık', 'Cilt tonu eşitleme', 'Blackhead ve whitehead temizliği'],
    img: 'https://readdy.ai/api/search-image?query=professional%20facial%20skincare%20treatment%20at%20luxury%20beauty%20salon%2C%20woman%20receiving%20deep%20cleansing%20facial%20massage%2C%20soft%20pink%20towel%2C%20warm%20glowing%20light%2C%20elegant%20spa%20products%20on%20white%20marble%20surface&width=560&height=420&seq=s001&orientation=landscape',
    reverse: false,
  },
  {
    id: 'buz-epilasyon',
    name: 'Buz Epilasyon',
    category: 'Epilasyon',
    desc: 'Özel soğutma teknolojisi ile konforu en üst düzeye çıkarılmış epilasyon deneyimi. Isı hassasiyeti yaşamadan kalıcı sonuçlar.',
    benefits: ['Soğutmalı ağrısız uygulama', 'Tüm cilt tiplerine uygun', 'Hızlı seans süresi', 'Uzun süreli sonuçlar'],
    img: 'https://readdy.ai/api/search-image?query=ice%20cooling%20epilator%20hair%20removal%20treatment%20at%20premium%20beauty%20clinic%2C%20close%20up%20of%20cooling%20device%20on%20smooth%20skin%2C%20sterile%20white%20and%20pink%20medical%20spa%20environment%2C%20soft%20professional%20lighting&width=560&height=420&seq=s002&orientation=landscape',
    reverse: true,
  },
  {
    id: 'mezo',
    name: 'İğnesiz Mezoterapi',
    category: 'Cilt Gençleştirme',
    desc: 'İğne kullanmadan vitamin, mineral ve hyaluronik asidi derin doku katmanlarına ulaştıran devrimsel teknoloji.',
    benefits: ['İğnesiz ağrısız uygulama', 'Hyaluronik asit desteği', 'Vitamin ve mineral kompleksi', 'Anında ışıltı etkisi'],
    img: 'https://readdy.ai/api/search-image?query=mesotherapy%20treatment%20without%20needles%20at%20luxury%20aesthetic%20clinic%2C%20woman%20receiving%20electroporation%20skin%20treatment%2C%20glowing%20healthy%20skin%2C%20elegant%20beauty%20salon%20with%20gold%20and%20cream%20decor&width=560&height=420&seq=s003&orientation=landscape',
    reverse: false,
  },
  {
    id: 'g5',
    name: 'G5 Bölgesel İncelme',
    category: 'Vücut Şekillendirme',
    desc: 'Güçlü titreşim teknolojisi ile bölgesel yağ dokusunu parçalayıp lenfatik drenajı hızlandıran etkili bir vücut şekillendirme yöntemi.',
    benefits: ['Selülit azaltma', 'Bölgesel yağ kırma', 'Kan dolaşımını hızlandırma', 'Cilt sıkılaştırma'],
    img: 'https://readdy.ai/api/search-image?query=G5%20massage%20body%20slimming%20treatment%20at%20high-end%20beauty%20salon%2C%20vibrating%20massage%20device%20on%20smooth%20skin%2C%20woman%20lying%20on%20white%20treatment%20bed%2C%20clean%20pink%20and%20white%20medical%20aesthetic%20environment&width=560&height=420&seq=s004&orientation=landscape',
    reverse: true,
  },
  {
    id: 'kalici-makyaj',
    name: 'Kalıcı Makyaj (PhiBrows)',
    category: 'Kalıcı Makyaj',
    desc: 'Dünya lideri PhiBrows tekniği ile her yüz şekline özel tasarım. Doğal görünümlü, uzun ömürlü ve mükemmel kaş çizgisi.',
    benefits: ['PhiBrows sertifikalı uzman', 'Yüz şekline özel tasarım', '1-2 yıl kalıcılık', 'Doğal pigment kullanımı'],
    img: 'https://readdy.ai/api/search-image?query=PhiBrows%20microblading%20permanent%20makeup%20eyebrow%20treatment%20at%20upscale%20beauty%20studio%2C%20close%20up%20of%20perfect%20natural-looking%20eyebrows%20being%20shaped%2C%20beauty%20technician%20working%20with%20precision%20tool%2C%20elegant%20pink%20and%20gold%20salon%20decor&width=560&height=420&seq=s005&orientation=landscape',
    reverse: false,
  },
  {
    id: 'ameliyatsiz',
    name: 'Ameliyatsız Yüz Germe',
    category: 'Estetik',
    desc: 'HIFU teknolojisi ile derideki kollajen üretimini uyararak derin yüz germe etkisi elde edin. Bıçaksız, iğnesiz, sürpriz sonuçlar.',
    benefits: ['Cerrahi gerektirmez', 'HIFU ultrason teknolojisi', 'Kollajen üretimi stimülasyonu', 'Sonuçlar 3-6 ay içinde oluşur'],
    img: 'https://readdy.ai/api/search-image?query=non-surgical%20HIFU%20face%20lifting%20treatment%20at%20luxury%20beauty%20clinic%2C%20ultrasound%20device%20being%20applied%20to%20cheek%2C%20woman%20with%20lifted%20rejuvenated%20skin%2C%20premium%20medical%20spa%20with%20champagne%20gold%20and%20white%20aesthetics&width=560&height=420&seq=s006&orientation=landscape',
    reverse: true,
  },
  {
    id: 'lazer-epilasyon',
    name: 'Lazer Epilasyon',
    category: 'Epilasyon',
    desc: 'Son nesil lazer teknolojisi ile tüm vücut bölgelerinde kalıcı tüy azaltma. Hızlı, konforlu ve uzun ömürlü sonuçlar.',
    benefits: ['FDA onaylı lazer teknolojisi', 'Tüm vücut uygulaması', 'Minimum ağrı maksimum etki', 'Seans bazlı kalıcı sonuç'],
    img: 'https://readdy.ai/api/search-image?query=laser%20hair%20removal%20session%20at%20premium%20beauty%20clinic%2C%20advanced%20diode%20laser%20device%20treating%20smooth%20skin%2C%20clinical%20clean%20environment%20with%20soft%20pink%20lighting%2C%20professional%20aesthetic%20medical%20equipment&width=560&height=420&seq=s007&orientation=landscape',
    reverse: false,
  },
  {
    id: 'igneli-epilasyon',
    name: 'İğneli Epilasyon',
    category: 'Epilasyon',
    desc: 'Elektroliz yöntemi ile kıl kökünü kalıcı olarak yok eden tek FDA onaylı epilasyon türü. Hassas bölgeler için ideal.',
    benefits: ['Tek gerçek kalıcı epilasyon', 'FDA onaylı yöntem', 'Tüm tüy renkleri için uygun', 'Hassas bölge uzmanlığı'],
    img: 'https://readdy.ai/api/search-image?query=electrolysis%20hair%20removal%20treatment%20close%20up%20at%20professional%20beauty%20salon%2C%20fine%20precision%20needle%20near%20skin%2C%20sterile%20clean%20environment%2C%20soft%20clinical%20lighting%2C%20elegant%20aesthetic%20beauty%20clinic%20with%20cream%20tones&width=560&height=420&seq=s008&orientation=landscape',
    reverse: true,
  },
];

export default function ServicesSection() {
  const whatsapp = (name: string) =>
    `https://wa.me/905412190629?text=${encodeURIComponent(`Merhaba, ${name} hakkında bilgi almak istiyorum.`)}`;

  return (
    <section id="detayli-hizmetler" className="py-20 bg-[#FFF8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">Tüm Hizmetlerimiz</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            Uzman Ekibimizle
            <br />
            <em className="text-[#D4AF37]">Güzelliğe Açılan Kapı</em>
          </h2>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        <div className="space-y-24">
          {services.map((svc) => (
            <div
              key={svc.id}
              className={`flex flex-col ${svc.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-10 md:gap-16`}
            >
              {/* Image */}
              <div className="w-full md:w-1/2 flex-shrink-0">
                <div className="relative rounded-2xl overflow-hidden group">
                  <img
                    src={svc.img}
                    alt={svc.name}
                    className="w-full h-72 md:h-96 object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/90 backdrop-blur-sm text-[#D4AF37] text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider">
                      {svc.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4">
                    <a
                      href={whatsapp(svc.name)}
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="flex items-center gap-2 bg-[#25D366] text-white text-xs font-semibold px-4 py-2.5 rounded-full hover:bg-[#1DA851] transition-colors shadow-lg whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line"></i>
                      Hemen Bilgi Al
                    </a>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2">
                <h3 className="font-serif text-2xl md:text-3xl text-[#2D2D2D] font-bold mb-4">{svc.name}</h3>
                <p className="text-[#6B6B6B] text-sm leading-relaxed mb-6">{svc.desc}</p>
                <ul className="space-y-3 mb-8">
                  {svc.benefits.map((b, i) => (
                    <li key={i} className="flex items-center gap-3 text-[#2D2D2D] text-sm">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#D4AF37]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#D4AF37] text-xs"></i>
                      </span>
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="flex flex-wrap gap-3">
                  <a
                    href={whatsapp(svc.name)}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full text-sm font-semibold hover:bg-[#1DA851] transition-all hover:-translate-y-0.5 whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line"></i>
                    Bu İşlem İçin Bilgi Al
                  </a>
                  <a
                    href={`https://wa.me/905412190629?text=${encodeURIComponent(`Merhaba, ${svc.name} fiyatı hakkında bilgi almak istiyorum.`)}`}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="flex items-center gap-2 border-2 border-[#D4AF37] text-[#D4AF37] px-5 py-3 rounded-full text-sm font-semibold hover:bg-[#D4AF37] hover:text-white transition-all hover:-translate-y-0.5 whitespace-nowrap"
                  >
                    <i className="ri-price-tag-3-line"></i>
                    Fiyat Öğren
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
